import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { IPrPppzSubmissionEntity } from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { createDateFromPeriod, createPeriodFromDate } from "@pages/payroll/payroll.utils";
import { setCompanyRelation } from "@pages/payroll/submission/Submission.utils";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";
import { PeriodLocalContextPath } from "@pages/payroll/submission/submissionTypes/PrPppzSubmission.def";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { FormStorage } from "../../../../views/formView/FormStorage";

class PrPppzSubmissionFormView extends SubmissionsFormViewForExtend<IPrPppzSubmissionEntity> {
    typeCode = PrSubmissionTypeCode.EmployersHealthInsurancePaymentOverview;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee: string = null;

    async typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;
        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            promises.push(setCompanyRelation(storage as unknown as FormStorage, { insurancePayer: true, withAddress: true, withPhoneNumber: true }));
        }

        if (entity.Detail?.Month && entity.Detail?.Year) {
            const period = createDateFromPeriod(entity.Detail);
            storage.setValueByPath(PeriodLocalContextPath, period);
        }

        await Promise.all(promises);
    }

    handleChange(e: ISmartFieldChange) {
        super.handleChange(e);

        const shouldUpdate = e.triggerAdditionalTasks !== false;
        this.props.storage.refreshFields(shouldUpdate);
    }

    onBeforeSave(data?: IPrPppzSubmissionEntity): IPrPppzSubmissionEntity {
        data = super.onBeforeSave(data);

        if (!data.Detail) {
            data.Detail = {};
        }

        const date = this.props.storage.getValueByPath(PeriodLocalContextPath);
        if (date) {
            const { Month, Year } = createPeriodFromDate(date);
            data.Detail.Month = Month;
            data.Detail.Year = Year;
        }

        if (!data.SubmissionSubtypeCode) {
            data.SubmissionSubtypeCode = PrSubmissionSubtypeCode.PppzRegular;
        }

        return data;
    }
}

export default withPermissionContext(PrPppzSubmissionFormView);